import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Provider } from 'react-redux'
import { store, AppDispatch } from './store'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCurrentUser, clearUser } from './redux/userSlice'
import { configureAuth } from '@adthlete/shared-frontend'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { registerDevTools } from './utils/devTools'

registerDevTools()

// Register the service worker for every visitor, not just users who enable push, so the browser
// treats the app as installable. Same URL and scope as usePushNotifications, so it's reused.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL })
      .catch(() => {})
  })
}

// Configure the shared in-memory auth store: which API to refresh against, a per-app
// BroadcastChannel for multi-tab token sharing, and how to clear user state on session loss.
configureAuth({
  apiBaseUrl: '/api',
  channelName: 'adthlete_athlete_auth',
  appId: 'athlete',
  onAuthCleared: () => store.dispatch(clearUser()),
})

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

const Root = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (!isMockMode) {
      dispatch(fetchCurrentUser())
    }
  }, [dispatch])

  return <App />
}

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <Provider store={store}>
      <Root />
    </Provider>
  </ErrorBoundary>,
)
